import React from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import { Container, Row } from 'reactstrap';
import LearningFilter from '../Common/LearningFilter';
import LearningDeatil from './LearningDeatil';

const DetailCourseContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Detailed Course' parent='Learning' title='Detailed Course' />
      <Row>
        <LearningDeatil />
        <LearningFilter />
      </Row>
    </Container>
  );
};

export default DetailCourseContainer;
